module.exports = __webpack_public_path__ + "img/5.2e820227.jpg";